@let memberDataValue = memberData();
@let memberStatusValue = memberStatus();

<div class="container">
  <div class="member-data">
    <div class="member-cell-start">
      <rt-avatar
        [type]="!!avatarThumbUrl() ? 'image' : 'initials'"
        [imageSrc]="avatarThumbUrl()"
        [fullName]="fullName()"
        [size]="'medium'"
        [context]="'admin'"
      />
    </div>
    <div class="member-cell-end">
      <div class="name-wrapper">
        <span class="name">{{ fullName() }}</span>
        <div class="badges">
          @if (isOwner()) {
            <rt-badge color="draft" [text]="'tlc.members.isOwnerBadge' | translate | uppercase" />
          }
          <tlc-edit-member-status
            [currentStatus]="memberStatusValue!"
            [hasWorkEmail]="hasWorkEmail()"
            [hasPersonalEmail]="!!memberDataValue?.personalEmail"
            [loginMethod]="loginMethod()"
            [usersWithoutEmails]="usersWithoutEmails() ?? false"
            [orgHasGrowStandalone]="orgHasGrowStandalone()"
          />
        </div>
      </div>

      @if (hasWorkEmail()) {
        <span class="email">{{ email() }}</span>
      } @else {
        <span class="email">{{ memberDataValue?.login }}</span>
      }
    </div>
  </div>
  <div class="actions-wrapper">
    <tlc-edit-member-status-actions
      [currentStatus]="memberStatusValue!"
      [hasWorkEmail]="hasWorkEmail()"
      [hasPersonalEmail]="!!memberDataValue?.personalEmail"
      [loginMethod]="loginMethod()"
      [usersWithoutEmails]="usersWithoutEmails()"
      [orgHasGrowStandalone]="orgHasGrowStandalone()"
      (actionClicked)="onStatusActionClicked($event)"
    />
    <rt-icon-button
      #moreDropdownTrigger="rtOverlayOrigin"
      rt-overlay-origin
      variant="outline"
      shape="square"
      size="medium"
      [iconName]="'more-horiz'"
      [pressed]="moreDropdown.open"
      (click)="toggleActionsMenu(moreDropdown)"
    />
  </div>
</div>

<ng-template
  #moreDropdown="rtConnectedOverlay"
  [origin]="moreDropdownTrigger"
  (backdropClick)="toggleActionsMenu(moreDropdown)"
  rt-connected-overlay
  hasBackdrop
>
  <rt-dropdown [width]="DropdownWidth.Large">
    <!-- Action Invite -->
    @if (memberStatusValue === TeamMemberStatus.NotInvited) {
      <rt-dropdown-item (click)="actionInvite()">
        <rt-icon prefix name="send" />
        <rt-heading variant="heading block">
          {{ 'tlc.members.edit_member.actions.invite.dropdown_title' | translate }}
        </rt-heading>
        <div class="info-dropdown-text">
          {{ 'tlc.members.edit_member.actions.invite.description' | translate }}
        </div>
      </rt-dropdown-item>
    }

    <!-- Action Send password reset email-->
    @if (loginMethod() === 'email' && memberStatusValue === TeamMemberStatus.Active) {
      <rt-dropdown-item (click)="actionSendPasswordResetEmail()">
        <rt-icon prefix name="vpn-key" />
        <rt-heading variant="heading block">
          {{
            'tlc.members.edit_member.actions.send_password_reset_email.dropdown_title' | translate
          }}
        </rt-heading>
        <div class="info-dropdown-text">
          {{ 'tlc.members.edit_member.actions.send_password_reset_email.description' | translate }}
        </div>
      </rt-dropdown-item>
    }

    <!-- Action Reset password -->
    @if (
      usersWithoutEmails() &&
      loginMethod() === 'username' &&
      (memberStatusValue === TeamMemberStatus.Active ||
        memberStatusValue === TeamMemberStatus.TemporaryPassword)
    ) {
      <rt-dropdown-item (click)="resetPassword()">
        <rt-icon prefix name="vpn-key" />
        <rt-heading variant="heading block">
          {{ 'tlc.members.edit_member.actions.reset_password.dropdown_title' | translate }}
        </rt-heading>
        <div class="info-dropdown-text">
          {{ 'tlc.members.edit_member.actions.reset_password.description' | translate }}
        </div>
      </rt-dropdown-item>
    }

    <!-- Action Start preonboarding -->
    @if (
      usersWithoutEmails() &&
      memberStatusValue === TeamMemberStatus.NotInvited &&
      !orgHasGrowStandalone()
    ) {
      <rt-dropdown-item (click)="actionStartPreonboarding()">
        <rt-icon prefix name="preonboarding-journey" />
        <rt-heading variant="heading block">
          {{ 'tlc.members.edit_member.actions.start_preonboarding.dropdown_title' | translate }}
        </rt-heading>
        <div class="info-dropdown-text">
          {{ 'tlc.members.edit_member.actions.start_preonboarding.description' | translate }}
        </div>
      </rt-dropdown-item>
    }

    <!-- Action Add employee to the list without giving them access -->
    @if (
      usersWithoutEmails() && memberStatusValue === TeamMemberStatus.NotInvited && !hasKiwiSeat()
    ) {
      <rt-dropdown-item (click)="actionAddEmployeeToTheListWithoutAccess([memberDataValue!])">
        <rt-icon prefix name="playlist-add" />
        <rt-heading variant="heading block">
          {{
            'tlc.members.edit_member.actions.add_employee_to_the_list_without_access.dropdown_title'
              | translate
          }}
        </rt-heading>
        <div class="info-dropdown-text">
          {{
            'tlc.members.edit_member.actions.add_employee_to_the_list_without_access.description'
              | translate
          }}
        </div>
      </rt-dropdown-item>
    }

    <!-- Action Change login method -->
    @if (usersWithoutEmails() && loginMethod() === 'username') {
      <rt-dropdown-item (click)="changeLoginMethod()">
        <rt-icon prefix name="gdpr-candidate" />
        <rt-heading variant="heading block">
          {{ 'tlc.members.edit_member.actions.change_login_method.dropdown_title' | translate }}
        </rt-heading>
        <div class="info-dropdown-text">
          {{ 'tlc.members.edit_member.actions.change_login_method.description' | translate }}
        </div>
      </rt-dropdown-item>
    }

    <!-- Action Pause access (For future) -->
    <!--    @if (loginMethod() === 'username' || hasTemporaryPassword()) {-->
    <!--    <rt-dropdown-item>-->
    <!--      <rt-icon prefix name="pause" (click)="actionPauseAccess()"/>-->
    <!--      <rt-heading variant="heading block">-->
    <!--        {{ 'tlc.members.edit_member.actions.pause_access.dropdown_title' | translate }}-->
    <!--      </rt-heading>-->
    <!--      <div class="info-dropdown-text">-->
    <!--        {{ 'tlc.members.edit_member.actions.pause_access.description' | translate }}-->
    <!--      </div>-->
    <!--    </rt-dropdown-item>-->
    <!--    }-->

    <!-- Action Deactivate -->
    @if (showDeactivate()) {
      @if (memberStatusValue !== TeamMemberStatus.Deactivated) {
        <rt-dropdown-item
          (click)="deactivateUserClicked()"
          [hasDivider]="hasDropdownItemsAboveDeactivate()!"
        >
          <rt-icon prefix name="member-deactivate" colorToken="colorIconCriticalDefault" />
          <rt-heading variant="heading block">
            {{ 'tlc.members.edit_member.actions.deactivation.dropdown_title' | translate }}
          </rt-heading>
          <div class="info-dropdown-text">
            {{ 'tlc.members.edit_member.actions.deactivation.description' | translate }}
          </div>
        </rt-dropdown-item>
      }

      @if (memberStatusValue === TeamMemberStatus.Deactivated) {
        <rt-dropdown-item
          (click)="deleteUserClicked()"
          [hasDivider]="hasDropdownItemsAboveDeactivate()!"
        >
          <rt-icon prefix name="delete-forever" colorToken="colorIconCriticalDefault" />
          <rt-heading variant="heading block">
            {{ 'tlc.members.edit_member.actions.deletion.dropdown_title' | translate }}
          </rt-heading>
          <div class="info-dropdown-text">
            {{ 'tlc.members.edit_member.actions.deletion.description' | translate }}
          </div>
        </rt-dropdown-item>
      }
    }
  </rt-dropdown>
</ng-template>
